import { render, staticRenderFns } from "./ConnectYourWallet.vue?vue&type=template&id=ff6cc660&"
import script from "./ConnectYourWallet.vue?vue&type=script&lang=js&"
export * from "./ConnectYourWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports